// extracted by mini-css-extract-plugin
module.exports = {"text":"ItemPlaceholderSSR_text__FgmZR","container":"ItemPlaceholderSSR_container__Y1o1Y"};